exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=radio]:checked + label[data-v-402f3657]{\n  background-color: var(--theme-primary);\n  border-color: var(--theme-primary);\n  color: #FFFFFF;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-402f3657","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/SelectAdultCoverage.vue
// module id = 585
// module chunks = 0